import { Badge } from '@radix-ui/themes';
import { t } from 'i18next';
import {
  PlayerStatusCode,
  getPlayerStatusColor,
  getPlayerStatusDisplay,
} from 'lib_ts/enums/mlb-stats-api/base.enum';

export const PlayerStatusBadge = (props: {
  value: PlayerStatusCode | undefined;
}) => {
  const display = getPlayerStatusDisplay(props.value);
  const color = getPlayerStatusColor(props.value);

  if (!display) {
    return null;
  }

  return <Badge color={color}>{t(display)}</Badge>;
};
